import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, f = { key: 1 }, A = { key: 2 }, k = { key: 3 }, y = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconMagnifyingGlass"
}, v = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: a } = M(r);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(i.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", Z, t[0] || (t[0] = [
        n("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", A, t[2] || (t[2] = [
        n("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", k, t[3] || (t[3] = [
        n("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", y, t[4] || (t[4] = [
        n("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", h, t[5] || (t[5] = [
        n("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  v as default
};
